var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlechaVision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    transform: "matrix(1 0 0 -1 13 51.5)",
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 23C31 22.4477 31.4477 22 32 22C32.5523 22 33 22.4477 33 23L31 23ZM32.7071 41.7071C32.3166 42.0976 31.6834 42.0976 31.2929 41.7071L24.9289 35.3431C24.5384 34.9526 24.5384 34.3195 24.9289 33.9289C25.3195 33.5384 25.9526 33.5384 26.3431 33.9289L32 39.5858L37.6569 33.9289C38.0474 33.5384 38.6805 33.5384 39.0711 33.9289C39.4616 34.3195 39.4616 34.9526 39.0711 35.3431L32.7071 41.7071ZM33 23L33 41L31 41L31 23L33 23Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaVision);
export default __webpack_public_path__ + "static/media/flechaVision.04bd294ae64b40709455230ba2f1fa11.svg";
export { ForwardRef as ReactComponent };